<template>
    <div class="md-card md-theme-default">
        <form method="POST" :action="action" ref="form" enctype="multipart/form-data" class="jobs-offers-form md-card-content md-alignment-center">
            <input type="hidden" name="_token" :value="csrkToken">
            <div class="form-row">
                <md-field :class="{'md-invalid': !!error['job_title_id']}">
                    <label>{{$t('job-candidature.job_name')}}</label>
                    <md-select v-model="formDataObj['job_title_id']">
                        <md-option 
                            v-for="job_name in job_names"
                            :key="job_name.id"
                            :value="job_name.id"
                        >
                            {{ job_name.title }}
                        </md-option>
                    </md-select>
                    <span class="md-error">{{error['job_title_id'] ? error['job_title_id'][0] : ''}}</span>
                </md-field>
                <input type="hidden" name="job_title_id" v-model="formDataObj['job_title_id']">
            </div>
            <div class="form-row">
                <md-field :class="{'md-invalid': !!error['first_name']}">
                    <label>{{$t('job-candidature.first_name')}}</label>
                    <md-input type="text" v-model="formDataObj['first_name']" name="first_name" required></md-input>
                    <span class="md-error">{{error['first_name'] ? error['first_name'][0] : ''}}</span>
                </md-field>
                <md-field :class="{'md-invalid': !!error['last_name']}">
                    <label>{{$t('job-candidature.last_name')}}</label>
                    <md-input type="text" v-model="formDataObj['last_name']" name="last_name" required></md-input>
                    <span class="md-error">{{error['last_name'] ? error['last_name'][0] : ''}}</span>
                </md-field>
            </div>
            <div class="form-row">
                <md-field :class="{'md-invalid': !!error['email']}">
                    <label>{{$t('job-candidature.email')}}</label>
                    <md-input type="email" v-model="formDataObj['email']" name="email" required></md-input>
                    <span class="md-error">{{error['email'] ? error['email'][0] : ''}}</span>
                </md-field>
                <phone-field v-model="formDataObj['phone']" :errors="error['phone']" :label="$t('job-candidature.phone')" :country-id="country_id" required></phone-field>
                <input type="hidden" name="phone" v-bind:value="formDataObj['phone']">
            </div>
            <label>{{$t('job-candidature.english_level')}}</label>
            <vue-slider class="form-row range-slider" :min="0" :max="3" :formatter="computeSliderLabel" v-model="formDataObj['english_level']" tooltip-dir="bottom"></vue-slider>
            <input type="hidden" name="english_level" :value="formDataObj['english_level']">
            <div class="form-row">
                <md-field>
                    <label>{{$t('job-candidature.message')}}</label>
                    <md-textarea type="textarea" v-model="formDataObj['message']" name="message"></md-textarea>
                    <span class="md-error">{{error['message'] ? error['message'][0] : ''}}</span>
                </md-field>
            </div>
            <div class="form-row">
                <label :class="{'md-field': true, 'md-theme-default': true, 'md-required': true, 'md-has-value': cv !== null, 'input_file': true, 'md-invalid': invalidCV}">
                    <label>{{ $t('job-candidature.cv') }}</label>
                    <span class="md-input">{{ !!cv ? cv['name'] : '' }}</span>
                    <md-icon>attach_file</md-icon>
                    <span class="md-error">{{ error['file_cv'] ? error['file_cv'][0] : '' }}</span>
                    <input type="file" style="display:none" @change="onCVChange($event, 2000)" name="file_cv" id="file_cv" accept=".pdf,.odt,.doc">
                </label>
                <label :class="{'md-field': true, 'md-theme-default': true, 'md-has-value': motivation_letter !== null, 'input_file': true, 'md-invalid': invalidMotivationLetter}">
                    <label>{{ $t('job-candidature.motivation_letter') }}</label>
                    <span class="md-input">{{ !!motivation_letter ? motivation_letter['name'] : '' }}</span>
                    <md-icon>attach_file</md-icon>
                    <span class="md-error">{{ error['file_motivation_letter'] ? error['file_motivation_letter'][0] : '' }}</span>
                    <input type="file" style="display:none" @change="onMotivationLetterChange($event, 2000)" name="file_motivation_letter" id="motivation_letter" accept=".pdf,.odt,.doc">
                </label>
            </div>
            <div class="md-card-actions md-alignment-right">
                <md-button class="jobs_offers_submit md-raised md-button md-primary md-theme-default" :disabled="invalidMotivationLetter || invalidCV" type="submit">
                    <div class="md-ripple md-disabled">
                        <div class="md-button-content">
                            {{$t('job-candidature.submit')}}
                        </div>
                    </div>
                </md-button>
            </div>
        </form>
        <md-dialog-alert
            :md-active.sync="internal_is_submited"
            :md-title="$t('job-candidature.submitted-title')"
            :md-content="$t('job-candidature.submitted-content')"
        />
    </div>
</template>

<script>
import vueSlider from 'vue-slider-component';
import PhoneField from './widgets/PhoneFieldComponent.vue';

export default {
    components: {
        vueSlider,
        PhoneField,
    },
    mounted() {
        this.internal_is_submited = this.is_submited;
        this.formDataObj = {...this.formDataObj, ...this.old_values};
        if(! this.formDataObj['phone']) {
            this.formDataObj['phone'] = "";
        }
        this.formDataObj['english_level'] = 0;
        if (this.error && this.error.file_cv) {
            this.invalidCV = true;
        }
        if (this.error && this.error.file_motivation_letter) {
            this.invalidMotivationLetter = true;
        }
    },
    props: {
        job_names: Array,
        action: String,
        error: Array|Object,
        old_values: Array|Object,
        is_submited: Boolean,
        country_id: String,
    },
    data() {
        return {
            formDataObj: {
                first_name: null,
                last_name: null,
                email: null,
                file_motivation_letter: {
                    name: '',
                },
                file_cv: {
                    name: '',
                },
                job_title_id: null,
                english_level: null,
                phone: "",
                message: null,
            },
            invalidMotivationLetter: false,
            invalidCV: false,
            internal_is_submited: null,
            cv: null,
            motivation_letter: null,
            slider_value: 0,
            csrkToken: Laravel.csrfToken,
        };
    },
    methods: {
        onCVChange(event, max_size) {
            let file = event.target.files[0];
            this.cv = file;
            if( this.checkSize(file, max_size)) {
                this.error['file_cv'] = [];
                this.invalidCV = false;
            } else {
                this.error['file_cv'] = [this.$t('validation.custom.file_cv.lte', {value: max_size})];
                this.invalidCV = true;
            }
        },
        onMotivationLetterChange(event, max_size) {
            let file = event.target.files[0];
            this.motivation_letter = file;
            if( this.checkSize(file, max_size)) {
                this.error['file_motivation_letter'] = [];
                this.invalidMotivationLetter = false;
            } else {
                this.error['file_motivation_letter'] = [this.$t('validation.custom.file_motivation_letter.lte', {value: max_size})];
                this.invalidMotivationLetter = true;
            }
        },
        computeSliderLabel: function(value) {
            return this.$t('job-candidature.english-level-' + value);
        },
        checkSize: function (event, max_size) {
            return event.size < max_size * 1000;
        },
    },
}
</script>

<style lang="scss" scoped>
.range-slider {
    padding-bottom: 45px !important;
    font-size: 16px;
}

.input_file {
    cursor: pointer;
}
</style>


<style lang="scss">
.md-overlay.md-fixed, body>.md-overlay {
    z-index: 9;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/JobCandidatureComponent.vue